module.exports = __webpack_public_path__ + "img/3097341-30-2.e09de2b9.png";